import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {
		ready: false,
	}
});

if (!('serviceWorker' in navigator)) {
	console.log('service workers not supported 😣') 
	//return
}
else {
	console.log('service workers supported') 
  }

window.initMap = function ready() {
	app.$set({ ready: true });
}



export default app;